export default function pricingEstimateHasPrice({ pricingEstimate }) {
  return undefined !== pricingEstimate?.amount;
}
